module.exports = __webpack_public_path__ + "static/WSlogo_transparent-794bed2d6018d292f93231374d6b2cb5.png";